module.exports = __webpack_public_path__ + "img/2_no.b8900305.svg";